<template>
  <v-container py-0 fluid>
    <v-card color="transparent" flat light>
      <v-card-text class="py-0">
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.name') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ getName(tournament.name) }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.tournaments.participantsQuantity') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ participants.length }} /
            {{ tournament.numberParticipants }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.tournaments.matchesDuration') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ tournament.matchesDuration }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.tournaments.participants') }}
          </v-flex>
          <v-flex xs12 md8>
            <v-chip
              v-for="(participant, index) of participants"
              :key="index + 233"
              color="transparent"
              small
            >
              <v-avatar size="32" style="padding: 0">
                <img :src="participant.img" alt />
              </v-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="body-1">
                  {{ participant.name }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  v-if="participant.categories"
                  class="caption grey--text text--lighten-1 text-truncate"
                >
                  {{ participant.categories.join(', ') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-chip>
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2" />
          <v-flex xs12 md6 />
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.tournaments.dates') }}
          </v-flex>
          <v-flex xs12 md6>
            <v-chip color="primary" small dark class="body-2">
              {{ formatDate(tournament.startAt.split('T')[0]) }} </v-chip
            >/
            <v-chip color="error" small dark class="body-2">
              {{ formatDate(tournament.endAt.split('T')[0]) }}
            </v-chip>
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.location') }}
          </v-flex>
          <v-flex xs12 md6>
            <v-chip
              v-for="(stadium, index) of tournament.stadiumId"
              :key="index + 533"
              color="transparent"
              small
              class="body-2"
            >
              <v-avatar>
                <v-img
                  ref="photo"
                  :src="stadium.photo"
                  @error="onImgError('photo')"
                />
              </v-avatar>
              {{ stadium.name }}
            </v-chip>
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.roles.description') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ getName(tournament.description) }}
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { formatDate } from '@/helpers'

export default {
  name: 'TabInformation',
  props: {
    tournament: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      viewModal: false,
    }
  },
  computed: {
    participants() {
      let participants = []
      if (this.tournament.type === 'teams') {
        participants = this.tournament.teams || []
      } else if (this.tournament.type === 'users') {
        participants = this.tournament.users || []
      }

      return participants.filter((item) => item.confirmed && item.inscribed)
    },
  },
  methods: {
    formatDate(date) {
      return formatDate(date)
    },
  },
}
</script>

<style scoped lang="scss">
// .dataTour {
//   display: grid;
//   width: 100%;
//   grid-template-columns: 30% auto;

//   div {
//     padding: 10px;
//     border-bottom: 1px solid rgba(0, 0, 0, 0.12);
//   }
// }
</style>
